import { useCallback, useEffect, useState } from "react";
import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut, getJenkinsResponse } from "../../services/networkService";
import { Paper, Table } from "@mantine/core";
import { TableBody, Box, Modal, TableCell, TableContainer, TableHead, TableRow, Typography, TextField, Button, Stack, IconButton } from "@mui/material";
import { faBolt, faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import store from "../../stateManagement/store";
import "./jenkinsDetails.css"
import AceEditor from "react-ace";
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/mode-powershell';
import { openPopup } from "../../stateManagement/actions/popupActions";


type ApiResponse = {
  attributes: any;
  cronExpression?: string;
  nextSchedule: string
  jobName: string;
  id: string;
  result: string;
  profileName: string;
};


export function Jenkins() {
  const [jenkinsConfig, setJenkinsConfig] = useState<ApiResponse[]>([]);

  const fetchAPi = useCallback(async () => {

    const response = await getJenkinsResponse();
    if (response.status === 200)
      return response.data.features;
    else
      return [];

  }, []);

  useEffect(() => {
    setJenkinsConfig([]);
    (async () => {

      let result = await fetchAPi();
      setJenkinsConfig((prevState) => prevState.concat(result))

    })()
  }, [fetchAPi]);



  return (
    <Stack padding={"25px"} spacing={5}>
      <h4 className="integration-dashboard-heading">Jenkins Job Details</h4>
      {
        jenkinsConfig.length > 0 ?
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Job Name</TableCell>
                  <TableCell>Cron Expression</TableCell>
                  <TableCell>Lob</TableCell>
                  <TableCell style={{textAlign:'center'}}>Button Action</TableCell>
                  <TableCell>Next Schedule</TableCell>
                  <TableCell>LastBuildNumber</TableCell>
                  <TableCell>LastBuildResult</TableCell>
                  <TableCell>ProfileName</TableCell>
                  <TableCell>ConsoleLog</TableCell>
                  <TableCell>Attributes</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {renderJobDetails(jenkinsConfig)}
              </TableBody>
            </Table>
          </TableContainer> : <div>No data available</div>
      }</Stack>
  );
}

function renderJobDetails(allSchedules: ApiResponse[]) {

  return allSchedules.map((schedule: ApiResponse,idx:number) => (
    <TableRow key={`${schedule.jobName}-${idx}`}>
      <TableCell className='jenkins-table-row'>
        <h5>{schedule.jobName}</h5>
      </TableCell>
      <TableCell className='jenkins-table-row'>
        <h5>{schedule.cronExpression}</h5>
      </TableCell>
      <TableCell className='jenkins-table-row'>
        <h5>{schedule.attributes.LOB}</h5>
      </TableCell>
      <TableCell >
        <EditJobButton jobInfo={schedule} />
      </TableCell>
      <TableCell className='jenkins-table-row'>
        {schedule.nextSchedule}
      </TableCell>
      <TableCell className='jenkins-table-row'>
        {schedule.id}
      </TableCell>
      <TableCell className='jenkins-table-row'>
        {schedule.result}
      </TableCell>
      <TableCell className='jenkins-table-row'>
        {schedule.profileName}
      </TableCell>
      <TableCell className='jenkins-table-row'>
        <ShowConsoleLog jobName={schedule.jobName} buildNumber={schedule.id} profileName={schedule.profileName} />
      </TableCell>
      <TableCell>
        <ShowAttributes>
          <CodeBlock fontSize='0.9rem' mode='javascript' value={JSON.stringify(schedule.attributes,null,2)} />
        </ShowAttributes>
      </TableCell>
    </TableRow>
  ));
}

function CodeBlock(props:{value:string, mode:string, fontSize?:string}){

  return (
    <AceEditor className="jenkins-code"
      readOnly
      setOptions={{
        showLineNumbers:false,
        showGutter:false,
        printMargin:false,
        showPrintMargin:false,
        wrap:true,
        maxLines:Infinity,
        wrapBehavioursEnabled:true,
        enableAutoIndent:true
      }}
      highlightActiveLine={false}
      mode={props.mode}
      editorProps={{$blockScrolling: true}}
      fontSize={props.fontSize || '0.75rem'}
      wrapEnabled
      width="100%"
      height="100%"
      value={props.value}
    />
  )
}

function ShowAttributes(props:{children:any}){
  const [openModal,setOpenModal] = useState<boolean>(false);
  
  return (
    <>
      <Button className='jenkins-table-button' onClick={()=>setOpenModal(true)} variant="contained">View</Button>
      <Modal open={openModal} onClose={()=>setOpenModal(false)}>
        <Box className='jenkins-modal' style={{width:"50%"}}>
          {props.children}
        </Box>
      </Modal>
    </>
  )
}

function ShowConsoleLog(props: { jobName: string, buildNumber: string ,profileName: string}) {
  const [consoleLog, setConsoleLog] = useState<string>("No data available");
  const [openModal, setOpenModal] = useState<boolean>(false);
  const handleClose = () => setOpenModal(false);

  useEffect(() => {

    (async () => {

      let result = await getConsoleLog(props.jobName, props.buildNumber,props.profileName);
      setConsoleLog(result.data.features[0]);

    })()
  }, [props.buildNumber, props.jobName,props.profileName]);

  return <>

    {openModal && <Modal
      open={openModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className='jenkins-modal'>
        <div>
          <Button className="jenkins-table-button jenkins-console-close-btn" onClick={(e) => setOpenModal(false)} variant={"contained"}>
            close
          </Button>
        </div>
        <CodeBlock mode='powershell' value={consoleLog}/>
      </Box>
    </Modal>}

    <Button className="jenkins-table-button" onClick={(e) => setOpenModal(true)} variant={"contained"}>
      view
    </Button>
  </>
}


function EditJobButton(props: { jobInfo: any }) {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [jobState, setJobState] = useState<any>(props.jobInfo);
  const handleClose = () => {
    setJobState(props.jobInfo);
    setOpenModal(false);
  }

  const ifAttributesAvailable:boolean = editableKeys.map(test=>{
    let splitKeys = test.toLowerCase().split(".");
    console.log(Object.keys(jobState.attributes).map(item => item.toLowerCase()));
    if(splitKeys.length === 1 && Object.keys(jobState.attributes).map(item => item.toLowerCase()).includes(splitKeys[0])) return true;
    else if (jobState.attributes.EXTRA_PARAMS && Object.keys(jobState.attributes.EXTRA_PARAMS).map(item => item.toLowerCase()).includes(splitKeys[1])) return true;
    else return false;
  }).filter(s=>s).length > 0;


  return (
    <Box display={'flex'} justifyContent={'space-evenly'}>
      <IconButton size="small" onClick={(e) => triggerJob(jobState)} title='Trigger Job' style={{position:"relative"}}>
        <FontAwesomeIcon icon={faBolt} /><Typography position={'absolute'}  style={{transform:'translate(-15%, 120%)'}} variant="caption" paddingLeft={'2px'} fontSize={'0.5rem'}>Trigger</Typography>
      </IconButton>

      <IconButton size="small" onClick={(e) => setOpenModal(true)} title='Edit Job' style={{position:"relative"}}>
        <FontAwesomeIcon icon={faPen} /><Typography position={'absolute'} style={{transform:'translate(-15%, 120%)'}} variant="caption" paddingLeft={'2px'} fontSize={'0.5rem'}>Edit</Typography>
      </IconButton>

      {openModal && <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className='jenkins-modal' style={{width:"50%"}}>
          {ifAttributesAvailable ?<Stack spacing={3}>
            {editableKeys.map(test => {
              let splitKeys = test.split(".");
              return (splitKeys.length === 1) ?
                (Object.keys(jobState.attributes).includes(test)) &&
                <TextField
                  required
                  id={test}
                  label={test}

                  variant="standard"
                  value={jobState.attributes[test]}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setJobState({ ...jobState, attributes: { ...jobState.attributes, [test]: event.target.value } });
                  }}
                /> :
                (jobState.attributes.EXTRA_PARAMS) &&
                <TextField
                  required
                  id={splitKeys[1]}
                  label={splitKeys[1]}

                  variant="standard"
                  value={jobState.attributes.EXTRA_PARAMS[splitKeys[1]]}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setJobState({ ...jobState, attributes: { ...jobState.attributes, EXTRA_PARAMS: { ...jobState.attributes.EXTRA_PARAMS, [splitKeys[1]]: event.target.value } } });
                  }}
                />
            })}

            <Box display={'flex'} justifyContent={'space-between'}>
              <Button className="jenkins-table-button" onClick={handleClose} variant={"contained"}>
                cancel
              </Button>

              <Button className="jenkins-table-button" onClick={(e) => triggerJob(jobState)} variant={"contained"}>
                triggerJob
              </Button>
            </Box>

          </Stack>:<div>No fields to edit</div>}

        </Box>
      </Modal>}
    </Box>
  )
}

async function triggerJob(jobInfo: any) {
  let valid = validateObj(jobInfo);
  if(valid){
    const res = await triggerJenkins("put", JSON.stringify(jobInfo));
    if(res.status === 200 || res.status===201){
      openPopup("Success","Job triggered successfully")
    }else {
      openPopup("Error","Failed to trigger job")
    }
  }
}



function validateObj(jobInfo: any){
  let validate=true;
  let failedField = "";
  for(var i=0;i<editableKeys.length;i++){
    let currKey = editableKeys[i];
    if(currKey.split(".").length===1){
      if(jobInfo.attributes && jobInfo.attributes[currKey]===""){
        validate= false;
        failedField = currKey;
        break;
      }
    }else{
      if(jobInfo.attributes && jobInfo.attributes.EXTRA_PARAMS && jobInfo.attributes.EXTRA_PARAMS[currKey.split(".")[1]] && jobInfo.attributes.EXTRA_PARAMS[currKey.split(".")[1]]===""){
        validate= false;
        failedField = currKey.split(".")[1];
        break;
      }
    }
  }
  if(!validate){
   openPopup("Error",failedField+" cannot be empty or null ")
  }
  return validate;
}

var editableKeys = ["Kpi_Name", "SYNC_TYPE", "userDivision", "EXTRA_PARAMS.--entityNameInFileHash"];

export async function triggerJenkins(httpVerb: string, transformerJSON: string): Promise<{ data: any, status: any }> {
  const url = `/v1/jenkinsJobDetails/editJob`
  if (httpVerb === "POST") {
    return await ChannelkartNetworkPost(url, transformerJSON, { "Content-Type": "application/json" });
  } else {
    return await ChannelkartNetworkPut(url, transformerJSON, { "Content-Type": "application/text" });
  }
}

export async function getConsoleLog(jobName: string, buildNumber: string,profileName: string): Promise<{ data: any, status: any }> {
  const url = `/v1/jenkinsJobDetails/${jobName}/${buildNumber}/${profileName}/consolelog`
  const response = await ChannelkartNetworkGet(url);
  return response
}
